import { jsx as _jsx } from "react/jsx-runtime";
export var RemoveIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    var iconSize = {
        small: 'size-4',
        medium: 'size-6',
        large: 'size-8',
    };
    return (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', className: iconSize[size], children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M6 18 18 6M6 6l12 12' }) }));
};
